declare global {
  interface Window {
    _smReadyFuncs: any;
    SMSdk: any;
    _smConf: any;
  }
}
/* eslint-disable */
export function getSm() {
  return new Promise(function (resolve, reject) {
    window._smReadyFuncs = [];
    window.SMSdk = {
      ready: function (fn:any) {
        fn && window._smReadyFuncs.push(fn);
      }
    };
    window._smConf = {
      organization: 'vy4mR7dCx1I4xsC1fLWR', //传入 organization，不要传入 accessKey. 
      staticHost: 'static.fengkongcloud.com'
    };
    var url = (function () {
      var originHost = "static2.fengkongcloud.com";
      var isHttps = 'https:' === document.location.protocol;
      var protocol = isHttps ? 'https://' : 'http://';
      var fpJsPath = '/fpv2.js';
      var url = protocol + window._smConf.staticHost + fpJsPath;
      var ua = navigator.userAgent.toLowerCase();
      var isWinXP = /windows\s(?:nt\s5.1)|(?:xp)/.test(ua);
      var isLowIE = /msie\s[678]\.0/.test(ua);
      if (isHttps && isWinXP && isLowIE) {
        url = protocol + originHost + fpJsPath;
      }
      return url;
    })();
    var sm = document.createElement("script");
    var s = document.getElementsByTagName("script")[0];
    sm.src = url;
    s.parentNode && s.parentNode.insertBefore(sm, s);
    sm.onload = function () {
      resolve(window.SMSdk.getDeviceId())
    }
    sm.onerror = reject
  })
}